/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { ValidationError, ValidationErrorItem } from 'joi'

/**************************************************************************************************/
/** @internal Interface @name Translations                                                       **/
/**************************************************************************************************/
interface Translations
{
	[key: string]: string
	base: string
	email: string
	empty: string
	max: string
	min: string
	required: string
}

/**************************************************************************************************/
/** @export Class @name JoiHelper                                                                **/
/**************************************************************************************************/
export class JoiHelper
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private static JoiReasonTranslations: Translations =
	{
		base: 'debe ser especificado',
		email: 'debe contener un formato valido',
		empty: 'no puede estar vacio',
		max: 'no puede superar los %s elemento(s) o caracter(es) de largo',
		min: 'debe contener al menos %s elemento(s) o caracter(es) de largo',
		required: 'es requerido'
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	private static _parseMessage(details: ValidationErrorItem) : string
	{
		const { label, limit } = details.context
		const reason = details.type.replace(/^\w+\./, '')
		let translated = JoiHelper.JoiReasonTranslations[reason]
		if (reason === 'max' || reason === 'min') translated = translated.replace('%s', limit)
		return `El Campo '${ label }' ${ translated }.`
	}

	public static showToastOnError(handler: Function, title: string, error: ValidationError) : void
	{
		const details = error.details[0]
		handler(title, JoiHelper._parseMessage(details), 'warning')
	}
}